module.exports = window["material-ui"];